import { Stack } from '@optimus-web/core';
import { PaymentLinkDialogContentProps } from './types';
import { PaymentLinkDetails } from './PaymentLinkDetails/PaymentLinkDetails';
import { PaymentLinkInvoiceForm } from './PaymentLinkInvoiceForm';

export const PaymentLinkInvoiceDialogContent = ({
    paymentId,
    accountId,
    serviceOrderId,
    ...props
}: PaymentLinkDialogContentProps) => (
    <Stack vertical spacing="200">
        <PaymentLinkDetails accountId={accountId} paymentId={paymentId} serviceOrderId={serviceOrderId} />
        <PaymentLinkInvoiceForm {...props} paymentId={paymentId} accountId={accountId} />
    </Stack>
);
